module.exports = "/_next/static/images/ae42e74993766d8262c66db8f124f49b-roxinho-card-with-phone-xs@3x.png";